export default __webpack_public_path__ + "static/Shawn-75f7dad2bfcbae1988440b303b5a465b.png";